import { SecurityType, SecurityTypeFormated } from '../../types/deal.types';

export function getSecurityTypeLabel(
  secType: SecurityType
): SecurityTypeFormated {
  return secType === SecurityType.option
    ? SecurityTypeFormated.Put
    : SecurityTypeFormated[secType];
}
